if (!customElements.get('nat-card-buy')) {
  customElements.define('nat-card-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const select = this.querySelector('select[name="id"]');
      const quantity = this.querySelector('[name="quantity"]');
      const button = this.querySelector('[type="submit"]');
      const price = this.closest('product-card')?.querySelector('.grid-price');
      const card = this.closest('product-card');
      const sizeButtons = [...this.querySelectorAll('[data-card-variant]')];
      const removeCardCod = () => {
        card?.querySelectorAll?.('#es-popup-button, .es-button-content').forEach((content) => {
          const control = content.matches?.('#es-popup-button') ? content : content.closest('button, a, [role="button"]');
          if (control && !control.classList.contains('nat-card-buy__submit')) control.remove();
          else content.remove();
        });
      };
      const update = () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        button.disabled = option.dataset.available !== 'true';
        button.querySelector('span').textContent = button.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
        if (price) {
          const current = document.createElement('span');
          current.className = 'nat-card-buy__price';
          current.textContent = option.dataset.price;
          price.replaceChildren(current);
          if (option.dataset.compare) {
            const old = document.createElement('s');
            old.textContent = option.dataset.compare;
            price.append(' ', old);
          }
        }
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        const min = Number(quantity.min), step = Number(quantity.step);
        let value = Math.max(min, Number(quantity.value) || min);
        value = min + Math.floor((value - min) / step) * step;
        if (quantity.max) value = Math.min(value, Number(quantity.max));
        quantity.value = String(value);
        this.querySelector('.product-form__error-message-wrapper').hidden = true;
      };
      select.addEventListener('change', update, {signal:this.abort.signal});
      sizeButtons.forEach((sizeButton) => {
        sizeButton.addEventListener('click', () => {
          if (sizeButton.disabled) return;
          select.value = sizeButton.dataset.cardVariant;
          sizeButtons.forEach((item) => {
            const active = item === sizeButton;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          select.dispatchEvent(new Event('change', { bubbles:true }));
        }, {signal:this.abort.signal});
      });
      // Keep a submission's variant and quantity stable until its request finishes.
      const loadingObserver = new MutationObserver(() => {
        const loading = button.classList.contains('loading');
        select.disabled = loading;
        quantity.readOnly = loading;
      });
      loadingObserver.observe(button, {attributes:true,attributeFilter:['class']});
      this.loadingObserver = loadingObserver;
      removeCardCod();
      if (card && typeof card.querySelectorAll === 'function') {
        this.appObserver = new MutationObserver(removeCardCod);
        this.appObserver.observe(card, {childList:true,subtree:true});
      }
      update();
    }
    disconnectedCallback() { this.abort?.abort();this.abort=null;this.loadingObserver?.disconnect();this.appObserver?.disconnect(); }
  });
}
